// src/components/bodyBlocks/contacto/ContactoBlock.tsx
import { useEffect } from 'react';
import FormularioContacto from '../../forms/contactoForm/ContactForm';
import InformacionContacto from '../../forms/contactoForm/InformacionContacto';
import ContactoHorario from '../../forms/contactoForm/ContactoHorario';
import ContactoRedesSociales from '../../forms/contactoForm/ContacoRedesSociales';

/**
 * 🧩 ContactoBlock
 * Componente principal de la sección de contacto.
 * Contiene:
 *  - Información de contacto
 *  - Horarios
 *  - Redes sociales
 *  - Formulario de contacto
 */
const ContactoBlock: React.FC = () => {
  // 🔹 useEffect para ajustar estilos globales del body
  useEffect(() => {
    // 🟢 Cambia el color de fondo del body al montar
    document.body.style.backgroundColor = '#52525B';
    // 🟢 Añade clase global para manejo de scroll personalizado
    document.body.classList.add("scroll-container");

    // 🔹 Cleanup: restaurar estilos al desmontar el componente
    return () => {
      document.body.style.backgroundColor = '';
      document.body.classList.remove("scroll-container");
    };
  }, []);

  return (
    <section className="flex justify-center items-start min-h-screen px-6 pt-32 pb-12">
      <div className="flex flex-col lg:flex-row w-full max-w-7xl gap-8 h-full">

        {/* 🔹 Columna izquierda */}
        <div className="flex flex-col gap-6 w-full lg:w-2/5 flex-1">
          {/* 🟢 Información básica de contacto */}
          <InformacionContacto />
          {/* 🟢 Horarios de atención */}
          <ContactoHorario />
          {/* 🟢 Redes sociales */}
          <ContactoRedesSociales />
        </div>

        {/* 🔹 Columna derecha: Formulario de contacto */}
        <div className="w-full lg:w-3/5 flex-1 flex">
          <div className="flex-1 flex items-stretch">
            <FormularioContacto />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactoBlock;
